<template>
    <div v-wechat-title="title" v-if="surgeryId && surgeryId > 0">
        <el-row
            style="min-height: 31px"
            v-if="
                !surgeryOccurEventConfig || canEdit
                // (cancelSurgeryPermission && surgeryInfo.enum_surgery_status == 20 && canEdit) ||
                // (receivePatientPermission && !isHaveReceivePatient && enum_surgery_status == 20 && canEdit)
            "
        >
            <el-col :span="19"><CusStep v-if="!surgeryOccurEventConfig" :steps="transportNode"> </CusStep></el-col>

            <el-col :span="5" style="position: absolute; right: 5px;bottom: 0px; display: flex; align-items: flex-end; justify-content: right; height: 100%;">
                <el-button
                    type="danger"
                    size="mini"
                    plain
                    style="float: right; margin-right: 5px"
                    v-has-permission="cancelSurgeryPermission"
                    v-if="surgeryInfo.enum_surgery_status == 20 && canEdit"
                    icon="el-icon-close"
                    @click="openCancelSurgery"
                    >取消手术</el-button
                >
                <el-button
                    type="primary"
                    size="mini"
                    plain
                    style="float: right; margin-right: 5px"
                    icon="el-icon-truck"
                    v-has-permission="receivePatientPermission"
                    v-if="!isHaveReceivePatient && enum_surgery_status == 20 && canEdit"
                    @click="receivePatient"
                    >接患者</el-button
                >
                <el-button
                    type="primary"
                    size="mini"
                    style="float: right; margin-right: 5px;"
                    v-if="canEdit"
                    @click="saveAllInfo"
                    >保存</el-button
                >
            </el-col>
        </el-row>
        <el-scrollbar wrap-class="scrollbar-wrapper-y" :style="{ height: this.screenHeight - 191 + 'px' }">
            <el-row>
                <el-col :md="24" :xl="12" class="padding10">
                    <el-card :body-style="{ padding: '5px' }">
                        <el-row class="card-header align-left line-height40" style="background: lightgray">
                            <el-col :span="16"
                                ><h3 class="margin20 margin-none-v">
                                    基本信息<i @click="drawer.baseInfo = !drawer.baseInfo" :class="drawer.baseInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                                </h3>
                            </el-col>
                        </el-row>
                        <div class="card-content" v-show="drawer.baseInfo">
                            <cus-form ref="basic-info" :data="surgeryInfo" :columns="basicInfoColumnList" @confirm="putbasicInfo"></cus-form>
                        </div>
                    </el-card>
                </el-col>
                <el-col :md="24" :xl="12">
                    <div class="padding10">
                        <el-card :body-style="{ padding: '5px' }">
                            <el-row class="card-header align-left line-height40" style="background: lightgray">
                                <el-col :span="16"
                                    ><h3 class="margin20 margin-none-v">
                                        手术信息<i @click="drawer.surgeryInfo = !drawer.surgeryInfo" :class="drawer.surgeryInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                                    </h3>
                                </el-col>
                            </el-row>
                            <div class="card-content" v-show="drawer.surgeryInfo">
                                <cus-form ref="surgery-info" :data="surgeryInfo" :columns="surgeryInfoColumnList" @confirm="putsurgeryInfo"></cus-form>
                            </div>
                        </el-card>
                    </div>
                    <div class="padding10">
                        <el-card :body-style="{ padding: '5px' }">
                            <el-row class="card-header align-left line-height40" style="background: lightgray">
                                <el-col :span="16"
                                    ><h3 class="margin20 margin-none-v">
                                        手术人员信息<i @click="drawer.userInfo = !drawer.userInfo" :class="drawer.userInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i></h3
                                ></el-col>
                            </el-row>
                            <div class="card-content" v-show="drawer.userInfo">
                                <span style="width: 50%; float: left; text-align: left; padding-left: 20px; font-size: 14px; font-weight: bold; margin-top: 5px; margin-bottom: 5px">计划：</span>
                                <span style="float: left; text-align: left; font-size: 14px; font-weight: bold; margin-top: 5px; margin-bottom: 5px">实际：</span>
                                <cus-form ref="surgery-worker" :data="surgeryInfo" :columns="surgeryWokerInfoColumnList" @confirm="putsurgeryWoker"></cus-form>
                            </div>
                        </el-card>
                    </div>
                </el-col>
                <el-col :md="24" :xl="24" v-show="this.surgeryInfo.enum_surgery_status >= 30" v-has-permission="factSurgeryShowPermission">
                    <div class="padding10">
                        <el-card :body-style="{ padding: '5px' }">
                            <el-row class="card-header align-left line-height40" style="background: lightgray">
                                <el-col :span="16"
                                    ><h3 class="margin20 margin-none-v">
                                        实际手术<i @click="drawer.playedsurgeryInfo = !drawer.playedsurgeryInfo" :class="drawer.playedsurgeryInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                                    </h3>
                                </el-col>
                            </el-row>
                            <div class="playedsurgery" v-show="drawer.playedsurgeryInfo">
                                <cus-form ref="played-surgery-info" :data="surgeryInfo" :columns="playedsurgeryInfoColumnList" @extrabutton-click="ExtraButtonClick" @confirm="savePlayedSurgery">
                                </cus-form>
                            </div>
                        </el-card>
                    </div>
                </el-col>
                <el-col :md="24" :xl="24" v-for="item in this.listextends" :key="item.obj.prop">
                    <div class="padding10">
                        <el-card :body-style="{ padding: '5px' }">
                            <el-row class="card-header align-left line-height40" style="background: lightgray">
                                <el-col :span="16"
                                    ><h3 class="margin20 margin-none-v">{{ item.obj.placeholder }}</h3></el-col
                                >
                            </el-row>
                            <div class="card-content">
                                <cus-form :ref="item.obj.placeholder" :data="surgeryInfo" :columns="item.items" @confirm="putsurgeryExtend"></cus-form>
                            </div>
                        </el-card>
                    </div>
                </el-col>
            </el-row>
            <el-row v-if="this.$root.DOCUMENT && this.$root.DOCUMENT.JBXX030">
                <el-col class="padding10">
                    <el-card :body-style="{ padding: '5px' }">
                        <el-row class="card-header align-left line-height40" style="background: lightgray">
                            <el-col :span="10"><h3 class="margin20 margin-none-v">其他</h3></el-col>
                            <el-col :span="14" class="align-right padding20 padding-none-v">
                                <div class="inline-block" v-if="activeDoc">
                                    <el-link
                                        type="primary"
                                        v-has-permission="hasSaveButtonPermission"
                                        v-if="activeDoc.isSurportHtml"
                                        size="mini"
                                        @click="saveDocument"
                                        class="margin20 margin-none-v"
                                        v-preventReClick
                                        ><span class="iconfont icon-baocun-xian"></span>保存</el-link
                                    >

                                    <el-link
                                        type="primary"
                                        v-has-permission="hasDisArchivePermission"
                                        v-if="activeDoc.archived && isTemplate == 0"
                                        size="mini"
                                        @click="disArchive(activeDoc)"
                                        class="margin20 margin-none-v"
                                        ><span class="iconfont icon-quxiaoshoucang"></span>取消归档</el-link
                                    >
                                    <el-link
                                        type="primary"
                                        v-has-permission="hasArchivePermission"
                                        v-if="!activeDoc.archived && isTemplate == 0"
                                        size="mini"
                                        @click="archive(activeDoc)"
                                        class="margin20 margin-none-v"
                                        ><span class="iconfont icon-shoucang"></span>归档</el-link
                                    >
                                    <el-link type="primary" v-has-permission="hasPrintButtonPermission" v-if="isTemplate == 0" size="mini" @click="printDocment" class="margin20 margin-none-v"
                                        ><span class="iconfont icon-dayin"></span>打印</el-link
                                    >
                                    <el-link
                                        type="primary"
                                        v-has-permission="hasRefreshButtonPermission"
                                        v-if="activeDoc.isSurportHtml"
                                        size="mini"
                                        @click="refreshDocument"
                                        class="margin20 margin-none-v"
                                        ><span class="iconfont icon-shuaxin"></span>刷新</el-link
                                    >
                                    <el-dropdown @command="saveAsTemplate" v-if="activeDoc.isSurportHtml">
                                        <el-link type="primary" size="mini" v-has-permission="hasSaveAsTemplatePermission"
                                            ><span class="iconfont icon-lingcunweimoban"></span>另存为模板<i class="el-icon-arrow-down el-icon--right"></i
                                        ></el-link>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="2">私有模板</el-dropdown-item>
                                            <el-dropdown-item command="1">区域模板</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    <div v-if="showSingle" class="inline-block width180">
                                        <item-input
                                            type="groupselect"
                                            :popperAppendToBody="true"
                                            :options="activeDoc.templates"
                                            v-model="activeDoc.templateid"
                                            placeholder="请选择模板"
                                            :clearable="true"
                                            @input="templateChange"
                                        ></item-input>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                        <div class="card-content">
                            <DocFrame
                                ref="doc"
                                v-if="activeDoc"
                                :docno="this.$root.DOCUMENT && this.$root.DOCUMENT.JBXX030"
                                :guid="`${surgeryId}_JBXX030`"
                                :surgeryId="surgeryId"
                                :docbizid.sync="activeDoc.docbizid"
                                :docname="`患者其他信息_${surgeryId}`"
                                :isSurportHtml="activeDoc.isSurportHtml"
                                :templateid="activeDoc.templateid"
                                :isHide="!activeDoc.archived"
                                @afterarchive="afterArchive"
                                @afterdisarchive="afterDisarchive"
                                @changed="changed"
                                @saved="afterActiveSaved"
                                @aftersaveastemplate="afterSaveasTemplate"
                            ></DocFrame>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </el-scrollbar>
        <form-dialog :title="overrule.title" :data="overrule.data" :visible.sync="overrule.dialogFormVisible" :columns="overrule.columns" @confirm="confirmCancelSurgery"></form-dialog>
        <form-dialog
            :title="modifySurgeryNameDialog.title"
            :data="modifySurgeryNameDialog.data"
            :visible.sync="modifySurgeryNameDialog.dialogFormVisible"
            :columns="modifySurgeryNameDialog.columns"
            @confirm="confirmModifySurgeryName"
        ></form-dialog>
    </div>
    <p v-else class="no-surgery">暂无手术</p>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
    name: `BasicInfo`,
    props: {},
    data() {
        let validateLength = (rule, value, callback) => {
            if (this.rejectReasons && this.rejectReasons.length > 0) {
                if (value && value.trim().length < 2) {
                    callback(new Error(`取消理由不能少于2个字符`))
                } else {
                    callback()
                }
            } else {
                if (value && value.trim().length < 4) {
                    callback(new Error(`取消理由不能少于4个字符`))
                } else {
                    callback()
                }
            }
        }
        return {
            title: `基本信息`,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            surgeryId: this.$route.query.surgery_id,
            factSurgeryShowWorkerAndSection: this.$root.factSurgeryShowWorkerAndSection,
            savetitle: null,
            saveColumns: [],
            transportNode: [],
            surgeryInfo: {},
            newSurgeryInfo: {},
            allTransEvents: [],
            listextends: [],
            isHaveReceivePatient: false,
            enum_surgery_status: 0,
            drawer: {
                baseInfo: true, // 控制基本信息页签折叠和展开
                surgeryInfo: true, // 控制手术信息页签折叠和展开
                userInfo: true, // 控制用户信息页签折叠和展开
                playedsurgeryInfo: true // 控制用户信息页签折叠和展开
            },
            visible: false,
            isSaving: false,
            activeDoc: undefined,
            isTemplate: 0, // 文书
            hasChanged: false,
            hasArchivePermission: `Document:Archive`,
            hasDisArchivePermission: `Document:DisArchive`,
            hasPrintButtonPermission: `Document:PrintButton`,
            hasRefreshButtonPermission: `Document:RefreshButton`,
            hasSaveAsTemplatePermission: `Document:SaveAsTemplate`,
            hasSaveButtonPermission: `Document:SeveButton`,
            cancelSurgeryPermission: `baseInfo:cancel_surgery`, // 取消手术
            receivePatientPermission: `baseInfo:receive_patient`, // 接患者
            factSurgeryShowPermission: `baseInfo:fact_surgery_manager`, // 实际手术卡片显示隐藏
            recordType: this.$route.query.record_type,
            documentList: [], // 文书模板列表
            archivedIds: [],
            isSingletonDocShowTemplate: this.$root.isSingletonDocShowTemplate || false,
            paperlessDocRecords: [],
            printlogDocRecords: [],
            PaperlessEnabled: this.$root.PaperlessEnabled,
            nextActive: undefined,
            archivedId: undefined,
            singleItems: [],
            isCanPrintDocAfterArchived: this.$root.isCanPrintDocAfterArchived || 0,
            applyRejectResons: this.$root.ApplyRejectResons,
            rejectReasons: [],
            removeItems: [],
            surgeriesOptions: [],
            overrule: {
                title: `取消手术`,
                dialogFormVisible: false,
                emitBtnName: `cancelSurgery`,
                data: {},
                columns: [
                    {
                        type: `select`,
                        prop: `reject_reason`,
                        label: `取消原因`,
                        config: {
                            allowCreate: true
                        },
                        options: this.rejectReasons,
                        validate: [
                            { validator: validateLength, trigger: `blur` },
                            { required: true, message: `必填项目`, trigger: `blur` }
                        ]
                    }
                ]
            },
            modifySurgeryNameDialog: {
                title: `修改手术名称`,
                dialogFormVisible: false,
                data: {},
                columns: [
                    {
                        type: `string`,
                        prop: `surgeryName`,
                        label: `手术名称`,
                        sortable: true,
                        width: `120`,
                        isListable: true
                    }
                ]
            },
            DocNo: this.$root.DOCUMENT.JBXX030,
            refeshDocument: true,
            required: this.$root.FactSurgerieRequires && this.$root.FactSurgerieRequires.split(`|`) || [],
            showModifySurgeryMode: this.$root.ShowModifySurgeryMode === `0` ? 1 : 2,
            token: this.$route.query.token,
            checkCutLevel: this.$root.CheckCutLevel || `0`,
            oldCutLevel: null,
            showFactColumns: this.$root.ShowFactColumns && this.$root.ShowFactColumns.split(`|`) || [],
            paperlessDocVerification: this.$root.carte_PaperlessDocVerification,
            surgeryOccurEventConfig: this.$root.SurgeryOccurEventConfig && _.includes(this.$root.SurgeryOccurEventConfig.trim().toLowerCase(), `proc_`),
            canEditSurgeryScale: this.$root.CanEditSurgeryScale,
            showExtendColumnList: []
        }
    },
    created() {
        //  加载所有枚举
        this.$store.dispatch(`enums/ADD_ALL_ENUM`)
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.$store.dispatch(`ADD_Inpatient_Section_AUTH`)
        this.$store.dispatch(`surgery/ADD_ANAESTHESIA_METHOD`)
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
            let doctoken = this.getToken()
            sessionStorage.setItem(`doctoken`, doctoken)
        }
        this.loadAllTransEvents()
        // 判断是否有基本信息-默认折叠 权限
        if (this.IsHavePermission(`baseInfo:collapse`)) {
            this.drawer.baseInfo = false
            this.drawer.surgeryInfo = false
            this.drawer.userInfo = false
        }

        // 获取session 记录的页签展开隐藏信息
        let tabUpDown = sessionStorage.getItem(`BasicTabUpDown`)
        if (tabUpDown) {
            var sessionDrawer = JSON.parse(tabUpDown)
            this.drawer.baseInfo = sessionDrawer.baseInfo
            this.drawer.surgeryInfo = sessionDrawer.surgeryInfo
            this.drawer.userInfo = sessionDrawer.userInfo
        }
        console.log(`begin`)
        console.log(this.currentUser)
        console.log(this.otherSettingColumn)
        console.log(this.extendColumnList)
        console.log(`end`)
    },
    mounted() {
        this.init()
        this.loadRejectResons()
        this.loadSurgeriesOptions()
    },
    computed: {
        ...mapGetters([
            `screenHeight`,
            `surgery/visit_type`,
            `surgery/anaesthesia_method`,
            `operation_room_auth`,
            `section_auth`,
            `inpatient_section_auth`,
            `operation_ward_auth`,
            `sys_enums`,
            `permissions`,
            `sysuser/workers_by_duty`,
            `sysuser/workers_by_dutyNew`,
            `currentSurgery`,
            `active_ward`,
            `currentUser`,
            `otherSettingColumn`,
            `extendColumnList`
        ]),
        isOperationWard() {
            // 判断是否手术区
            if (this.recordType) {
                if (this.recordType == `1`) {
                    return true
                } else {
                    return false
                }
            } else {
                return _.startsWith(this.active_ward.value, `ow_`)
            }
        },
        worker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        canEdit() {
            // 手术麻醉单归档后不能在保存
            let caneditarchived = this.IsHavePermission(`dic_surgery_caneditarchived`)
            if (caneditarchived) {
                return true
            } else {
                let cansave = this.surgeryInfo.is_archived ? false : this.IsHavePermission(`baseInfo:save`)
                return cansave
            }
        },
        basicInfoColumnList() {
            let list = [
                {
                    type: `select`,
                    prop: `enum_visit_type`,
                    label: `就诊类型`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    default: 1,
                    options: this.sys_enums.VisitType || [],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    config: { popperAppendToBody: true }
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`surgeryinfo.visit_no`),
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `姓名`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `outpatient_no`,
                    label: `门诊号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12
                },
                {
                    type: `datetime`,
                    prop: `visit_time`,
                    label: `入院时间`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12
                },
                {
                    type: `select`,
                    prop: `enum_sex`,
                    label: `性别`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    options: this.sys_enums.Enum_Sex || [],
                    config: { popperAppendToBody: true }
                },

                {
                    type: `string`,
                    prop: `nation`,
                    label: `民族`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12
                },
                {
                    type: `string`,
                    prop: `bed_no`,
                    label: `床号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12
                },
                {
                    type: `remoteselect`,
                    prop: `sectionobj`,
                    label: `科室`,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let sections = _.cloneDeep(this[`section_auth`])
                            console.log(`sections`, sections)
                            if (q && q.keyword) {
                                let f = sections.filter(d => {
                                    return d.code.indexOf(q.keyword) > -1 || d.label.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                                console.log(`f`, f)
                                return f
                            } else {
                                console.log(`search`, sections)
                                return sections
                            }
                        }
                    },
                    colspan: 12,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    config: { popperAppendToBody: true }
                },
                {
                    type: `remoteselect`,
                    prop: `inpatientobj`,
                    label: `病区`,
                    isCreatable: true,
                    isEditable: true,
                    // options:this["section_auth"],
                    // options: ,
                    options: (that, { row }) => {
                        return q => {
                            let sections = _.cloneDeep(this[`inpatient_section_auth`])
                            console.log(`sections`, sections)
                            if (q && q.keyword) {
                                let f = sections.filter(d => {
                                    return d.code.indexOf(q.keyword) > -1 || d.label.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                                console.log(`f`, f)
                                return f
                            } else {
                                console.log(`search`, sections)
                                return sections
                            }
                        }
                    },
                    colspan: 12,
                    default: this.dic_section_surgery,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `date`,
                    prop: `birthday`,
                    label: `出生日期`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    change: (that, { row }) => {
                        let bir = row.birthday
                        let currentDate = this.$moment()
                        let birthDate = this.$moment(bir || ``)
                        let age = this.$moment.duration(currentDate.diff(birthDate))._data
                        row.age = age.years == 0 ? (age.months == 0 ? `${age.days}天` : `${age.months}月`) : `${age.years}岁`
                    }
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12
                },
                {
                    type: `select`,
                    prop: `card_type`,
                    label: `证件类型`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    options: this.sys_enums.Enum_CardType || [],
                    config: { popperAppendToBody: true }
                },
                {
                    type: `string`,
                    prop: `card_no`,
                    label: `证件号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12
                },
                {
                    type: `string`,
                    prop: `address`,
                    label: `地址`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 24
                },
                {
                    type: `string`,
                    prop: `phone`,
                    label: `电话`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12
                },
                {
                    type: `select`,
                    prop: `is_vip`,
                    label: `VIP`,
                    isCreatable: true,
                    isEditable: true,
                    options: [
                        { label: `是`, value: 1 },
                        { label: `否`, value: 0 }
                    ],
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `visit_count`,
                    label: `就诊次数`,
                    isEditable: true,
                    readonly: true,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_pay_type`,
                    label: `费用类别`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_PayType || [],
                    colspan: 12,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `string`,
                    prop: `insurance_no`,
                    label: `社保卡号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12
                },
                {
                    type: `select`,
                    prop: `enum_blood_type`,
                    label: `血型`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_BloodType || [],
                    colspan: 12,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `select`,
                    prop: `enum_rh_blood_type`,
                    label: `RH`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_RhBloodType || [],
                    colspan: 12,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `string`,
                    prop: `height`,
                    label: `身高(cm)`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12
                },
                {
                    type: `string`,
                    prop: `weight`,
                    label: `体重(kg)`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12
                }
            ]
            // 批处理是否可编辑那些属性
            if (this.otherSettingColumn) {
                list = this.$surgeryInfoExtraParamUtil.SetOtherSettingColumn(list, this.otherSettingColumn)
            }

            // 分组的列单独渲染，未分组的放到手术申请基本信息栏
            let r = _.cloneDeep(this.showExtendColumnList)
            r = _.filter(r, d => {
                return ((d.data_group_name == null || d.data_group_name == ``) && (d.basic_group_name == null || d.basic_group_name == ``)) || d.basic_group_name == `基本信息`
            }).sort((a, b) => a.display_order - b.display_order)
            list = this.$surgeryInfoExtraParamUtil.SetExtraColumnList(
                r,
                list
            )
            list = _.filter(list, function(d) {
                return d.isEditable === true
            })
            if (this.showExtendColumnList) {
                this.listextends = this.$surgeryInfoExtraParamUtil.SetExtraColumnListToEdit(this.showExtendColumnList)
            }
            return list
        },
        surgeryInfoColumnList() {
            let me = this
            let factSurgeryShow = this.IsHavePermission(`baseInfo:fact_surgery_manager`)
            let status = this.surgeryInfo.enum_surgery_status
            let list = [
                {
                    type: `remotemultiselect`,
                    prop: `plan_diseases`,
                    label: `术前诊断`,
                    isCreatable: true,
                    isEditable: true,
                    showCount: 3,
                    collapseTags: false,
                    colspan: 24,
                    options: `/api/AcisSystem/Disease/Search`,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `remotemultiselect`,
                    prop: `fact_diseases`,
                    label: `术后诊断`,
                    isCreatable: true,
                    isEditable: true,
                    showCount: 3,
                    collapseTags: false,
                    colspan: 24,
                    options: `/api/AcisSystem/Disease/Search`,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_surgeries`,
                    label: `拟施手术`,
                    showCount: 3,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 24,
                    options: `/api/AcisSystem/Surgery/Search`,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `remotemultiselect`,
                    prop: `fact_surgeries`,
                    label: `已施手术`,
                    showCount: 3,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    readonly: status >= 30 && factSurgeryShow,
                    colspan: 24,
                    options: `/api/AcisSystem/Surgery/Search`,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `multiselect`,
                    prop: `plan_anaes_methods`,
                    label: `计划麻醉`,
                    showCount: 3,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    options: this[`surgery/anaesthesia_method`],
                    config: {
                        collapseTags: true
                    },
                    colspan: 24
                }, {
                    type: `multiselect`,
                    prop: `fact_anaes_methods`,
                    label: `实际麻醉`,
                    showCount: 3,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    options: this[`surgery/anaesthesia_method`],
                    config: {
                        collapseTags: true
                    },
                    colspan: 24
                },
                {
                    type: `select`,
                    prop: `enum_surgery_scale`,
                    label: `手术分级`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_SurgeryScale || [],
                    colspan: 12,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `select`,
                    prop: `enum_cut_level`,
                    label: `切口等级`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_CutLevel || [],
                    colspan: 12,
                    config: { popperAppendToBody: true },
                    change: (that, { row }) => {
                        if (me.checkCutLevel && me.checkCutLevel == `1` && row.enum_cut_level == 1) {
                            // me.$message.warning(`请确认是否I类手术切口`)
                            me.$alert(`<strong>请确认是否I类手术切口</strong>`, `提示`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            })
                        }
                    }
                }
            ]

            let r = _.cloneDeep(this.showExtendColumnList)
            r = _.filter(r, d => {
                return d.basic_group_name == `手术信息`
            }).sort((a, b) => a.display_order - b.display_order)
            list = this.$surgeryInfoExtraParamUtil.SetExtraColumnList(
                r,
                list
            )
            list = _.filter(list, function(d) {
                return d.isEditable === true
            })
            return list
        },
        surgeryWokerInfoColumnList() {
            let list = [
                {
                    type: `remoteselect`,
                    prop: `plan_surgeon`,
                    label: this.T(`surgeryinfo.plan_surgeon`),
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    options: (that, { row }) => {
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (this.$root.UseSurgeryScaleCheck == `1`) {
                                works = works.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        code: d.surgery_scale == null ? `--/${d.code}` : d.surgery_scale + `/` + d.code
                                    }
                                })
                            }
                            if (q && q.keyword) {
                                let f = works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                                return f
                            } else {
                                return works
                            }
                        }
                    },
                    config: { popperAppendToBody: true }
                },
                {
                    type: `remoteselect`,
                    prop: `fact_surgeon`,
                    label: this.T(`surgeryinfo.plan_surgeon`),
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    options: (that, { row }) => {
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (this.$root.UseSurgeryScaleCheck == `1`) {
                                works = works.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        code: d.surgery_scale == null ? `--/${d.code}` : d.surgery_scale + `/` + d.code
                                    }
                                })
                            }
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    config: { popperAppendToBody: true }
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_surgeon_assistants`,
                    label: this.T(`surgeryinfo.plan_surgeon_assistants`),
                    showCount: 4,
                    collapseTags: false,
                    isEditable: true,
                    isCreatable: true,
                    options: (that, { row }) => {
                        return q => {
                            let r = {
                                workerRole: 1,
                                keyword: q && q.keyword
                            }
                            return this.myaxios.get(`/api/AcisSystem/Worker/RemoteSearch`, r).then(
                                res => {
                                    if (this.$root.UseSurgeryScaleCheck == `1`) {
                                        return res.map(d => {
                                            return {
                                                label: d.label,
                                                value: d.value,
                                                jianpin: d.jianpin,
                                                card_no: d.card_no,
                                                worker_duty: d.worker_duty,
                                                code: d.surgery_scale == null ? `--/${d.code}` : d.surgery_scale + `/` + d.code
                                            }
                                        })
                                    } else {
                                        return res.map(d => {
                                            return {
                                                label: d.label,
                                                value: d.value,
                                                jianpin: d.jianpin,
                                                card_no: d.card_no,
                                                worker_duty: d.worker_duty,
                                                code: d.code
                                            }
                                        })
                                    }
                                },
                                res => {
                                    console.log(`error`) // 调用失败
                                }
                            )
                        }
                    },
                    colspan: 12,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `remotemultiselect`,
                    prop: `fact_surgeon_assistants`,
                    label: this.T(`surgeryinfo.plan_surgeon_assistants`),
                    showCount: 4,
                    collapseTags: false,
                    isEditable: true,
                    isCreatable: true,
                    options: (that, { row }) => {
                        return q => {
                            let r = {
                                workerRole: 1,
                                keyword: q && q.keyword
                            }
                            return this.myaxios.get(`/api/AcisSystem/Worker/RemoteSearch`, r).then(
                                res => {
                                    if (this.$root.UseSurgeryScaleCheck == `1`) {
                                        return res.map(d => {
                                            return {
                                                label: d.label,
                                                value: d.value,
                                                jianpin: d.jianpin,
                                                card_no: d.card_no,
                                                worker_duty: d.worker_duty,
                                                code: d.surgery_scale == null ? `--/${d.code}` : d.surgery_scale + `/` + d.code
                                            }
                                        })
                                    } else {
                                        return res.map(d => {
                                            return {
                                                label: d.label,
                                                value: d.value,
                                                jianpin: d.jianpin,
                                                card_no: d.card_no,
                                                worker_duty: d.worker_duty,
                                                code: d.code
                                            }
                                        })
                                    }
                                },
                                res => {
                                    console.log(`error`) // 调用失败
                                }
                            )
                        }
                    },
                    colspan: 12,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `remoteselect`,
                    prop: `plan_anes_doctor`,
                    label: this.T(`surgeryinfo.plan_anes_doctor`),
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (this.$root.UseASACheck == `1`) {
                                works = works.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                    }
                                })
                            }
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    colspan: 12,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `remoteselect`,
                    prop: `fact_anes_doctor`,
                    label: this.T(`surgeryinfo.plan_anes_doctor`),
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (this.$root.UseASACheck == `1`) {
                                works = works.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        //  code: d.code,
                                        // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                    }
                                })
                            }
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    colspan: 12,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_anes_assistants`,
                    label: this.T(`surgeryinfo.plan_anes_assistants`),
                    showCount: 4,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            // added by xiaorui,ACIS-23399  排程界面的麻醉助手权限改动：既可以选择医生，又可选择护士
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let deepworkers = _.cloneDeep(works)
                            let hsworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            hsworkers.forEach((item, index) => {
                                let mc = _.find(deepworkers, x => x.value == item.value)
                                if (mc) {
                                } else {
                                    deepworkers.push(item)
                                }
                            })
                            if (this.$root.UseASACheck == `1`) {
                                deepworkers = deepworkers.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        //  code: d.code,
                                        // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                        // code: d.surgery_scale == null ? `--/${d.code}` : d.surgery_scale + `/` + d.code
                                    }
                                })
                            }
                            if (q && q.keyword) {
                                return deepworkers.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return deepworkers
                            }
                        }
                    },
                    colspan: 12,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `remotemultiselect`,
                    prop: `fact_anes_assistants`,
                    label: this.T(`surgeryinfo.plan_anes_assistants`),
                    showCount: 4,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            // added by xiaorui,ACIS-23399  排程界面的麻醉助手权限改动：既可以选择医生，又可选择护士
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let deepworkers = _.cloneDeep(works)
                            let hsworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            hsworkers.forEach((item, index) => {
                                let mc = _.find(deepworkers, x => x.value == item.value)
                                if (mc) {
                                } else {
                                    deepworkers.push(item)
                                }
                            })
                            if (this.$root.UseASACheck == `1`) {
                                deepworkers = deepworkers.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        //  code: d.code,
                                        // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                        // code: d.surgery_scale == null ? `--/${d.code}` : d.surgery_scale + `/` + d.code
                                    }
                                })
                            }
                            if (q && q.keyword) {
                                return deepworkers.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return deepworkers
                            }
                        }
                    },
                    colspan: 12,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_circuit_nurse`,
                    label: this.T(`surgeryinfo.plan_circuit_nurse`),
                    showCount: 4,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    colspan: 12,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `remotemultiselect`,
                    prop: `fact_circuit_nurse`,
                    label: this.T(`surgeryinfo.plan_circuit_nurse`),
                    showCount: 4,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    colspan: 12,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_equipment_nurse`,
                    label: this.T(`surgeryinfo.fact_equipment_nurse`),
                    showCount: 4,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    colspan: 12,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `remotemultiselect`,
                    prop: `fact_equipment_nurse`,
                    label: this.T(`surgeryinfo.fact_equipment_nurse`),
                    showCount: 4,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    colspan: 12,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_technician_doctor`,
                    label: this.T(`surgeryinfo.plan_technician_doctor`),
                    showCount: 4,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`技师`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    colspan: 12,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `remotemultiselect`,
                    prop: `fact_technician_doctor`,
                    label: this.T(`surgeryinfo.fact_technician_doctor`),
                    showCount: 4,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`技师`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    colspan: 12,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `p`,
                    prop: `jieban`,
                    label: { content: `接班:` },
                    isEditable: true,
                    field_style: `font-weight:bold;text-align:left;text-align-last:left;margin-top:-10px;margin-bottom: 2px;`,
                    colspan: 24
                },
                {
                    type: `string`,
                    prop: `anesthesiologist_new`,
                    label: `麻醉医生`,
                    isEditable: true,
                    colspan: 12,
                    readonly: true
                }, {
                    type: `string`,
                    prop: `anesthesiologistAssts_new`,
                    label: `麻醉助手`,
                    isEditable: true,
                    colspan: 12,
                    readonly: true
                }, {
                    type: `string`,
                    prop: `circuit_nurse_new`,
                    label: `巡回护士`,
                    isEditable: true,
                    colspan: 12,
                    readonly: true
                }, {
                    type: `string`,
                    prop: `equipment_nurse_new`,
                    label: `器械护士`,
                    isEditable: true,
                    colspan: 12,
                    readonly: true
                }
            ]

            let r = _.cloneDeep(this.showExtendColumnList)
            r = _.filter(r, d => {
                return d.basic_group_name == `手术人员信息`
            }).sort((a, b) => a.display_order - b.display_order)
            list = this.$surgeryInfoExtraParamUtil.SetExtraColumnList(
                r,
                list
            )
            list = _.filter(list, function(d) {
                return d.isEditable === true
            })
            return list
        },
        playedsurgeryInfoColumnList() {
            let showMode = this.showModifySurgeryMode
            let table = [
                {
                    type: `table2`,
                    prop: `fact_surgery_items`,
                    label: ``,
                    isEditable: true,
                    isCreatable: true,
                    options: [{
                        type: `string`,
                        prop: `id`,
                        label: `id`,
                        area: [1, 2],
                        isKey: true
                    },
                    {
                        type: `string`,
                        prop: `prefix_name`,
                        label: `前缀`,
                        isListable: true,
                        readonly: false,
                        area: [1],
                        colspan: 2
                    },
                    {
                        type: `string`,
                        prop: `icd_code`,
                        label: this.T(`surgery.code`),
                        isListable: true,
                        readonly: true,
                        area: [2],
                        colspan: 2
                    },
                    {
                        type: `remoteselect`,
                        prop: `plan_surgeries`,
                        label: showMode == 2 ? `ICD手术名称` : `手术名称`,
                        showCount: 1,
                        isListable: true,
                        readonly: false,
                        colspan: 4,
                        area: [1, 2],
                        options: `/api/AcisSystem/Surgery/SearchIncludOpeLevel`,
                        change: (that, { row, index }) => {
                            if (row.is_empty) {
                                this.$set(row, `is_empty`, false)
                                this.surgeryInfo.fact_surgery_items.push({ is_empty: true })
                            }
                            if (_.isEmpty(row.plan_surgeries)) {
                                row.plan_surgery_scale = undefined
                                this.$set(row, `dic_worker`, null)
                                this.$set(row, `dic_section`, null)
                                this.$set(row, `plan_enum_cut_level`, null)
                                this.$set(row, `plan_surgery_region`, null)
                                this.$set(row, `plan_surgery_position`, null)
                                this.$set(row, `plan_anaes_method`, null)
                            } else {
                                if (index > 0) {
                                    console.log(this.surgeryInfo.fact_surgery_items)
                                    let predata = this.surgeryInfo.fact_surgery_items[index - 1]
                                    if (predata != null) {
                                        this.$set(row, `dic_worker`, predata.dic_worker)
                                        this.$set(row, `dic_section`, predata.dic_section)
                                        this.$set(row, `plan_enum_cut_level`, predata.plan_enum_cut_level)
                                        this.$set(row, `plan_surgery_region`, predata.plan_surgery_region)
                                        this.$set(row, `plan_surgery_position`, predata.plan_surgery_position)
                                        this.$set(row, `plan_anaes_method`, predata.plan_anaes_method)
                                    }
                                }

                                var max = -1
                                try {
                                    if (row.plan_surgeries.description) {
                                        let level = parseInt(row.plan_surgeries.description)
                                        if (level > max) { max = level }
                                    }
                                } catch (err) {
                                    console.log(err)
                                }
                                if (max > 0) {
                                    row.plan_surgery_scale = max
                                } else {
                                    row.plan_surgery_scale = undefined
                                }
                            }
                            if (showMode == 2) {
                                this.$set(row, `icd_code`, row.plan_surgeries.code)
                                this.$set(row, `plan_surgeries_name`, row.plan_surgeries.label)
                            }
                        },
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]

                    },
                    {
                        type: `string`,
                        prop: `plan_surgeries_name`,
                        label: `实际手术名称`,
                        isListable: true,
                        readonly: false,
                        config: { clearable: false },
                        area: [2],
                        width: 250,
                        colspan: 6
                    },
                    {
                        type: `string`,
                        prop: `behind_name`,
                        label: `后缀`,
                        isListable: true,
                        readonly: false,
                        area: [1],
                        colspan: 2
                    },
                    {
                        type: `select`,
                        prop: `plan_surgery_scale`,
                        label: `手术等级`,
                        isListable: true,
                        readonly: !(!this.$root.CanEditSurgeryScale || this.$root.CanEditSurgeryScale == `1`),
                        area: [1, 2],
                        options: this.sys_enums.Enum_SurgeryScale || [],
                        colspan: 2,
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                    },
                    {
                        type: `remoteselect`,
                        prop: `dic_worker`,
                        label: this.T(`surgeryinfo.plan_surgeon`),
                        isListable: this.factSurgeryShowWorkerAndSection == `1`,
                        area: [1, 2],
                        readonly: false,
                        colspan: 12,
                        options: (that, { row }) => {
                            return q => {
                                let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || []
                                let works = _.cloneDeep(deepworkers)
                                if (this.$root.UseSurgeryScaleCheck == `1`) {
                                    works = works.map(d => {
                                        return {
                                            label: d.label,
                                            value: d.value,
                                            jianpin: d.jianpin,
                                            card_no: d.card_no,
                                            worker_duty: d.worker_duty,
                                            code: d.surgery_scale == null ? `--/${d.code}` : d.surgery_scale + `/` + d.code
                                        }
                                    })
                                }
                                if (q && q.keyword) {
                                    let f = works.filter(d => {
                                        return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                    })
                                    return f
                                } else {
                                    return works
                                }
                            }
                        },
                        config: { popperAppendToBody: true }
                    },
                    {
                        type: `remoteselect`,
                        prop: `dic_section`,
                        label: `科室`,
                        isListable: this.factSurgeryShowWorkerAndSection == `1`,
                        area: [1, 2],
                        readonly: false,
                        options: (that, { row }) => {
                            return q => {
                                let sections = _.cloneDeep(this[`section_auth`])
                                console.log(`sections`, sections)
                                if (q && q.keyword) {
                                    let f = sections.filter(d => {
                                        return d.code.indexOf(q.keyword) > -1 || d.label.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                    })
                                    console.log(`f`, f)
                                    return f
                                } else {
                                    console.log(`search`, sections)
                                    return sections
                                }
                            }
                        },
                        colspan: 12,
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                        config: { popperAppendToBody: true }
                    },
                    {
                        type: `select`,
                        prop: `plan_enum_cut_level`,
                        label: `切口等级`,
                        isListable: true,
                        readonly: false,
                        options: this.sys_enums.Enum_CutLevel || [],
                        colspan: 2,
                        area: [1, 2],
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                    },
                    {
                        type: `select`,
                        prop: `plan_surgery_region`,
                        label: `部位`,
                        isCreatable: true,
                        isListable: true,
                        readonly: false,
                        options: this.sys_enums.Enum_Region || [],
                        colspan: 3,
                        area: [1, 2],
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                    },
                    {
                        type: `select`,
                        prop: `plan_surgery_position`,
                        label: `体位`,
                        isCreatable: true,
                        isListable: true,
                        readonly: false,
                        area: [1, 2],
                        options: this.sys_enums.Enum_Position || [],
                        colspan: 3
                    },
                    {
                        type: `select`,
                        prop: `plan_anaes_method`,
                        label: `麻醉方式`,
                        isListable: true,
                        readonly: false,
                        area: [1, 2],
                        options: (that, { row }) => {
                            return _.filter(this[`surgery/anaesthesia_method`], function(i) { return (i.enum_dic_type === 1 || i.enum_dic_type === 2) })
                        },
                        colspan: 3
                    },
                    {
                        type: `buttongroup`,
                        prop: `oper`,
                        label: `操作`,
                        width: `60`,
                        isListable: true,
                        fixed: `right`,
                        readonly: false,
                        area: [1, 2],
                        colspan: 2,
                        options: (that, { row }) => {
                            return row.is_empty || !row.plan_surgeries
                                ? []
                                : [
                                    {
                                        class: `is-plain is-circle`,
                                        label: ``,
                                        icon: `el-icon-close`,
                                        type: `danger`,
                                        emit: `removeItem`,
                                        permission: `default`
                                    }
                                ]
                        }
                    }
                    ],
                    colspan: 24,
                    default: [{
                        is_empty: true
                    }]
                }
            ]
            let cols = _.filter(table[0].options, d => {
                return d.area.indexOf(showMode) > -1
            })
            let baseCols = [`手术等级`, `切口等级`, `部位`, `体位`, `麻醉方式`]
            let cols2 = _.filter(cols, d => {
                return _.find(baseCols, f => f == d.label) == undefined || (_.find(baseCols, f => f == d.label) != undefined && _.find(this.showFactColumns, f => f == d.label) != undefined)
            })

            table[0].options = cols2
            return table
        },
        IsHavePermission() {
            return permissionNo => {
                return _.find(this.permissions, { no: permissionNo }) != undefined
            }
        },
        showSingle() {
            if (this.isSingletonDocShowTemplate && (this.isSingletonDocShowTemplate.toUpperCase() == `TRUE` || this.isSingletonDocShowTemplate.toUpperCase() == `1`)) {
                return this.activeDoc.isSurportHtml && this.activeDoc.is_singleton
            } else {
                return this.activeDoc.isSurportHtml && this.activeDoc.is_singleton && !this.activeDoc.hasChildren
            }
        },
        _surgeriesOptions() {
            return this.surgeriesOptions
        }
    },
    methods: {
        init() {
            if (this.surgeryId > 0) {
                this.showExtendColumnList = this.extendColumnList && this.extendColumnList.filter(d => {
                    return d.is_editable
                })
                this.loadTransportNode()
                this.loadOne().then(data => {
                    this.loadHandovers()
                    if (this.$root.DOCUMENT && this.$root.DOCUMENT.JBXX030) {
                        this.loadDocumentList()
                    }
                })
            }
        },
        loadRejectResons() {
            if (this.applyRejectResons && this.applyRejectResons.trim()) {
                this.rejectReasons = this.applyRejectResons.trim().split(`,`).map(x => {
                    return {
                        label: x,
                        value: x
                    }
                })
            } else {
                this.rejectReasons = []
            }
        },
        loadSurgeriesOptions() {
            let req = this.myaxios.getNoloading(`/api/AcisSystem/Surgery/SearchIncludOpeLevel`)
            req.then(data => {
                this.surgeriesOptions = data
            }).catch(e => {
                console.log(e)
            })
        },
        loadTransportNode() {
            if (!this.surgeryId) return
            let req = this.myaxios.getNoloading(`/api/Nursing/PatientTransport/GetSurgeryTransport/${this.surgeryId}`)
            req.then(data => {
                this.transportNode =
                    data &&
                    _.map(data, d => {
                        d.title = d.event_name
                        d.status = d.id > 0 ? `primary` : `info`
                        return d
                    })
                let mc = _.find(this.transportNode, f => f.title == `接患者`)
                if (mc) {
                    this.isHaveReceivePatient = true
                    console.log(`有接患者isHaveReceivePatient=true`)
                } else {
                    this.isHaveReceivePatient = false
                    console.log(`没有没有接患者isHaveReceivePatient=false`)
                }
            }).catch(e => {
                console.log(e)
            })
        },
        loadHandovers() {
            if (!this.surgeryId) {
                return
            }
            // 获取麻醉医生交班
            let req = this.myaxios.getNoloading(`/api/Nursing/ShiftWorker/Get?surgeryId=${this.surgeryId}&shiftType=1`)
            // 获取护士交班
            let req1 = this.myaxios.getNoloading(`/api/Nursing/ShiftWorker/Get?surgeryId=${this.surgeryId}&shiftType=2`)
            this.myaxios.all(req, req1).then(([hs, hs1]) => {
                let handover = {
                    circuit_nurse_new: ``,
                    equipment_nurse_new: ``,
                    anesthesiologistAssts_new: ``,
                    anesthesiologist_new: ``
                }
                let lsths = _.last(_.filter(hs, `id`)) // 最新的麻醉医生交班
                let lsths1 = _.last(_.filter(hs1, `id`)) // 最新的护士交班

                if (lsths) {
                    handover.anesthesiologist_new = lsths.anesthesiologist_new.map(c => c.label).toString()
                    handover.anesthesiologistAssts_new = lsths.anesthesiologistAssts_new.map(c => c.label).toString()
                }

                if (lsths1) {
                    handover.circuit_nurse_new = lsths1.circuit_nurse_new.map(c => c.label).toString()
                    handover.equipment_nurse_new = lsths1.equipment_nurse_new.map(c => c.label).toString()
                }

                this.surgeryInfo = Object.assign(
                    this.surgeryInfo,
                    handover
                )
            })
        },
        loadAllTransEvents() {
            let req = this.myaxios.getNoloading(`/api/Nursing/PatientTransport/GetAllTransEvents`)
            req.then(data => {
                this.allTransEvents = _.filter(data, { disabled: false })
            })
        },
        loadOne() {
            if (!this.surgeryId) return
            return new Promise(resolve => {
                let req = this.myaxios.getNoloading(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
                req.then(data => {
                    this.enum_surgery_status = data.enum_surgery_status
                    let obj = {
                        id: data.id,
                        is_archived: data.is_archived, // 手术对应的麻醉单是否已归档
                        plan_time: data.plan_time,
                        infectious: data.infectious && data.infectious.split(`,`),
                        is_fasting: data.is_fasting,
                        remark: data.remark,
                        enum_asa: data.enum_asa,
                        enum_surgery_status: data.enum_surgery_status,
                        enum_surgery_scale: data.enum_surgery_scale,
                        enum_surgery_type: data.enum_surgery_type,
                        dic_section_id: data.dic_section_id,
                        sectionobj: data.sectionobj,
                        inpatientobj: data.inpatientobj,
                        dic_inpatient_section_id: data.dic_inpatient_section_id,
                        dic_operating_room_id: data.dic_operating_room_id,
                        dic_operating_ward_id: data.dic_operating_ward_id,
                        enum_isolation_status: data.enum_isolation_status,
                        enum_cut_level: data.enum_cut_level,
                        age: data.visit_info.age,
                        nation: data.visit_info.nation,
                        height: data.visit_info.height,
                        weight: data.visit_info.weight,
                        bed_no: data.visit_info.bed_no,
                        visit_no: data.visit_info.visit_no,
                        outpatient_no: data.visit_info.outpatient_no,
                        visit_time: data.visit_info.visit_time,
                        phone: data.visit_info.phone,
                        is_vip: data.visit_info.is_vip,
                        visit_count: data.visit_info.visit_count,
                        address: data.visit_info.address,
                        enum_visit_type: data.visit_info.enum_visit_type,
                        enum_pay_type: data.visit_info.enum_pay_type,
                        name: data.visit_info.name,
                        birthday: data.visit_info.birthday,
                        card_type: data.visit_info.card_type,
                        card_no: data.visit_info.card_no,
                        insurance_no: data.visit_info.insurance_no,
                        enum_blood_type: data.visit_info.enum_blood_type,
                        enum_rh_blood_type: data.visit_info.enum_rh_blood_type,
                        enum_sex: data.visit_info.enum_sex,
                        plan_diseases: data.plan_diseases,
                        fact_diseases: data.fact_diseases,
                        plan_surgeries: data.plan_surgeries,
                        fact_surgeries: data.fact_surgeries,
                        plan_anaes_methods: data.plan_anaes_methods && data.plan_anaes_methods.map(d => d.value),
                        fact_anaes_methods: data.fact_anaes_methods && data.fact_anaes_methods.map(d => d.value),
                        surgery_items: data.surgery_items, // 拟施手术 Table展现形式
                        fact_surgery_items: data.fact_surgery_items, // 已施手术 Table展现形式
                        // 获取计划手术医生
                        plan_surgeon: data.plan_surgeon,
                        plan_surgeon_assistants: data.plan_surgeon_assistants,
                        plan_anes_doctor: data.plan_anes_doctor,
                        plan_anes_assistants: data.plan_anes_assistants,
                        plan_circuit_nurse: data.plan_circuit_nurse,
                        plan_equipment_nurse: data.plan_equipment_nurse,
                        plan_technician_doctor: data.plan_technician_doctor,
                        // 获取实际手术医生
                        fact_surgeon: data.fact_surgeon,
                        fact_surgeon_assistants: data.fact_surgeon_assistants,
                        fact_anes_doctor: data.fact_anes_doctor,
                        fact_anes_assistants: data.fact_anes_assistants,
                        fact_circuit_nurse: data.fact_circuit_nurse,
                        fact_equipment_nurse: data.fact_equipment_nurse,
                        fact_technician_doctor: data.fact_technician_doctor,
                        circuit_nurse_new: ``,
                        equipment_nurse_new: ``,
                        anesthesiologistAssts_new: ``,
                        anesthesiologist_new: ``, // 接班麻醉医生
                        source_hospital_ward_id: data.source_hospital_ward_id,
                        enum_outoperatingroomtype: data.enum_outoperatingroomtype
                    }

                    if (_.findIndex(obj.fact_surgery_items, { is_empty: true }) == -1) {
                        obj.fact_surgery_items.push({ is_empty: true })
                    }
                    // getone的时候把动态列字段放到obj对象里面
                    if (this.showExtendColumnList) {
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.showExtendColumnList, obj, data)
                    }
                    this.surgeryInfo = obj
                    if (this.surgeryInfo && this.surgeryInfo.id) {
                        this.$store.commit(`setCurrentSurgery`, this.surgeryInfo)
                    }
                    resolve(this.surgeryInfo)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        removeItem(index) {
            let row = this.surgeryInfo.fact_surgery_items.splice(index, 1)[0]
            if (row.id) {
                this.removeItems.push(row)
            }
        },
        ExtraButtonClick({ emit, row, index }) {
            if (emit == `removeItem`) {
                this.removeItem(index)
            }
        },
        putbasicInfo(data) {
            let that = this
            if (!this.surgeryId) return
            return new Promise(resolve => {
                if (!that.newSurgeryInfo) {
                    that.newSurgeryInfo = that.surgeryInfo
                }
                that.newSurgeryInfo.id = data.id
                that.newSurgeryInfo.fromPage = `baseInfo`
                that.newSurgeryInfo.dic_section_id = data.sectionobj && data.sectionobj.value
                that.newSurgeryInfo.dic_inpatient_section_id = data.inpatientobj && data.inpatientobj.value
                that.newSurgeryInfo.enum_outoperatingroomtype = data.enum_outoperatingroomtype
                that.newSurgeryInfo.visit_info = {
                    enum_visit_type: data.enum_visit_type,
                    visit_no: data.visit_no,
                    name: data.name,
                    outpatient_no: data.outpatient_no,
                    visit_time: data.visit_time,
                    enum_sex: data.enum_sex,
                    nation: data.nation,
                    bed_no: data.bed_no,
                    birthday: data.birthday,
                    age: data.age,
                    card_type: data.card_type,
                    card_no: data.card_no,
                    address: data.address,
                    phone: data.phone,
                    is_vip: data.is_vip,
                    visit_count: data.visit_count,
                    enum_pay_type: data.enum_pay_type,
                    insurance_no: data.insurance_no,
                    enum_blood_type: data.enum_blood_type,
                    enum_rh_blood_type: data.enum_rh_blood_type,
                    height: data.height,
                    weight: data.weight
                }
                // 修改的时候把动态列字段放到obj.extra_datas对象里面
                if (this.showExtendColumnList) {
                    let r = _.cloneDeep(this.showExtendColumnList)
                    r = _.filter(r, d => {
                        return ((d.data_group_name == null || d.data_group_name == ``) && (d.basic_group_name == null || d.basic_group_name == ``)) || d.basic_group_name == `基本信息`
                    })
                    if (r.length > 0) {
                        let oldExtraDatas = []
                        if (that.newSurgeryInfo.extra_datas) {
                            oldExtraDatas = _.cloneDeep(that.newSurgeryInfo.extra_datas)
                        }
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoExtraDatas(r, that.newSurgeryInfo, data)
                        let extraDatas = oldExtraDatas.filter(
                            (oldItem) => !that.newSurgeryInfo.extra_datas.some((newItem) => oldItem.DataKey === newItem.DataKey)
                        )
                        that.newSurgeryInfo.extra_datas = [...extraDatas, ...that.newSurgeryInfo.extra_datas]
                    }
                }
                resolve(that.newSurgeryInfo)
            })
        },
        putsurgeryInfo(data) {
            let that = this
            if (!this.surgeryId) return
            return new Promise(resolve => {
                if (!that.newSurgeryInfo) {
                    that.newSurgeryInfo = {}
                }
                // ACIS-25406 处理实际手术名称可能和字典不一样
                let factsurgeryname = data.fact_surgeries && data.fact_surgeries.map(d => d.label)
                let summaryname = factsurgeryname && factsurgeryname.length > 0 ? factsurgeryname.join(`,`) : ``
                let changeSummary = {
                    biz_surgery_info_id: data.id,
                    surgery: summaryname,
                    is_fasting: true
                }

                that.newSurgeryInfo.id = data.id
                that.newSurgeryInfo.plan_diseases = data.plan_diseases && data.plan_diseases.map(d => d.value)
                that.newSurgeryInfo.fact_diseases = data.fact_diseases && data.fact_diseases.map(d => d.value)
                that.newSurgeryInfo.plan_surgeries = data.plan_surgeries && data.plan_surgeries.map(d => d.value)
                that.newSurgeryInfo.fact_surgeries = data.fact_surgeries && data.fact_surgeries.map(d => d.value)
                that.newSurgeryInfo.plan_anaes_methods = data.plan_anaes_methods
                that.newSurgeryInfo.fact_anaes_methods = data.fact_anaes_methods
                that.newSurgeryInfo.enum_surgery_scale = data.enum_surgery_scale || `-1`
                that.newSurgeryInfo.enum_cut_level = data.enum_cut_level || `-1`
                that.newSurgeryInfo.change_summary_surgery = changeSummary

                var r = _.map(data.surgery_items, d => {
                    d.plan_surgeries = d.plan_surgeries && d.plan_surgeries.value
                    return d
                })
                that.newSurgeryInfo.surgery_items = r
                // 修改的时候把动态列字段放到obj.extra_datas对象里面
                if (this.showExtendColumnList) {
                    let r = _.cloneDeep(this.showExtendColumnList)
                    r = _.filter(r, d => {
                        return d.basic_group_name == `手术信息`
                    })
                    if (r.length > 0) {
                        let oldExtraDatas = []
                        if (that.newSurgeryInfo.extra_datas) {
                            oldExtraDatas = _.cloneDeep(that.newSurgeryInfo.extra_datas)
                        }
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoExtraDatas(r, that.newSurgeryInfo, data)
                        let extraDatas = oldExtraDatas.filter(
                            (oldItem) => !that.newSurgeryInfo.extra_datas.some((newItem) => oldItem.DataKey === newItem.DataKey)
                        )
                        that.newSurgeryInfo.extra_datas = [...extraDatas, ...that.newSurgeryInfo.extra_datas]
                    }
                }
                resolve(that.newSurgeryInfo)
            })
        },
        putsurgeryWoker(data) {
            let that = this
            if (!this.surgeryId) return
            return new Promise(resolve => {
                if (!that.newSurgeryInfo) {
                    that.newSurgeryInfo = {}
                }
                that.newSurgeryInfo.id = data.id
                that.newSurgeryInfo.plan_surgeon = data.plan_surgeon && data.plan_surgeon.value || `-1`
                that.newSurgeryInfo.fact_surgeon = data.fact_surgeon && data.fact_surgeon.value || `-1`
                that.newSurgeryInfo.plan_surgeon_assistants = data.plan_surgeon_assistants && data.plan_surgeon_assistants.map(d => d.value)
                that.newSurgeryInfo.fact_surgeon_assistants = data.fact_surgeon_assistants && data.fact_surgeon_assistants.map(d => d.value)
                that.newSurgeryInfo.plan_anes_doctor = data.plan_anes_doctor && data.plan_anes_doctor.value || `-1`
                that.newSurgeryInfo.fact_anes_doctor = data.fact_anes_doctor && data.fact_anes_doctor.value || `-1`
                that.newSurgeryInfo.plan_anes_assistants = data.plan_anes_assistants && data.plan_anes_assistants.map(d => d.value)
                that.newSurgeryInfo.fact_anes_assistants = data.fact_anes_assistants && data.fact_anes_assistants.map(d => d.value)
                that.newSurgeryInfo.plan_circuit_nurse = data.plan_circuit_nurse && data.plan_circuit_nurse.map(d => d.value)
                that.newSurgeryInfo.fact_circuit_nurse = data.fact_circuit_nurse && data.fact_circuit_nurse.map(d => d.value)
                that.newSurgeryInfo.plan_equipment_nurse = data.plan_equipment_nurse && data.plan_equipment_nurse.map(d => d.value)
                that.newSurgeryInfo.fact_equipment_nurse = data.fact_equipment_nurse && data.fact_equipment_nurse.map(d => d.value)
                that.newSurgeryInfo.plan_technician_doctor = data.plan_technician_doctor && data.plan_technician_doctor.map(d => d.value)
                that.newSurgeryInfo.fact_technician_doctor = data.fact_technician_doctor && data.fact_technician_doctor.map(d => d.value)

                // 修改的时候把动态列字段放到obj.extra_datas对象里面
                if (this.showExtendColumnList) {
                    let r = _.cloneDeep(this.showExtendColumnList)
                    r = _.filter(r, d => {
                        return d.basic_group_name == `手术人员信息`
                    })
                    if (r.length > 0) {
                        let oldExtraDatas = []
                        if (that.newSurgeryInfo.extra_datas) {
                            oldExtraDatas = _.cloneDeep(that.newSurgeryInfo.extra_datas)
                        }
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoExtraDatas(r, that.newSurgeryInfo, data)
                        let extraDatas = oldExtraDatas.filter(
                            (oldItem) => !that.newSurgeryInfo.extra_datas.some((newItem) => oldItem.DataKey === newItem.DataKey)
                        )
                        that.newSurgeryInfo.extra_datas = [...extraDatas, ...that.newSurgeryInfo.extra_datas]
                    }
                }
                resolve(that.newSurgeryInfo)
            })
        },
        putsurgeryExtend(data) {
            let that = this
            if (!this.surgeryId) return
            return new Promise(resolve => {
                if (!that.newSurgeryInfo) {
                    that.newSurgeryInfo = {}
                }
                that.newSurgeryInfo.id = data.id
                // 修改的时候把动态列字段放到obj.extra_datas对象里面
                if (this.showExtendColumnList) {
                    let r = _.cloneDeep(this.showExtendColumnList)
                    r = _.filter(r, d => {
                        return d.data_group_name == that.savetitle
                    })
                    if (r.length > 0) {
                        let oldExtraDatas = []
                        if (that.newSurgeryInfo.extra_datas) {
                            oldExtraDatas = _.cloneDeep(that.newSurgeryInfo.extra_datas)
                        }
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoExtraDatas(r, that.newSurgeryInfo, data)
                        let extraDatas = oldExtraDatas.filter(
                            (oldItem) => !that.newSurgeryInfo.extra_datas.some((newItem) => oldItem.DataKey === newItem.DataKey)
                        )
                        that.newSurgeryInfo.extra_datas = [...extraDatas, ...that.newSurgeryInfo.extra_datas]
                    }
                }
                resolve(that.newSurgeryInfo)
            })
        },
        saveAllInfo() {
            let that = this
            that.$refs[`basic-info`].confirm().then(() => {
                that.$refs[`surgery-info`].confirm().then(() => {
                    that.$refs[`surgery-worker`].confirm().then(() => {
                        const myPromise = new Promise(function(resolve, reject) {
                            if (that.listextends && that.listextends.length > 0) {
                                that.listextends.forEach((item, index) => {
                                    that.savetitle = item.obj.placeholder
                                    that.$refs[that.savetitle][0].confirm().then(() => {
                                        if (index == that.listextends.length - 1) {
                                            if (that.$refs[`played-surgery-info`] && that.$refs[`played-surgery-info`].$refs.ItemInput[0]) {
                                                that.newSurgeryInfo.fact_surgery_items = that.$refs[`played-surgery-info`].$refs.ItemInput[0].value
                                            }
                                            resolve(that.newSurgeryInfo)
                                        }
                                    })
                                })
                            } else {
                                if (that.$refs[`played-surgery-info`] && that.$refs[`played-surgery-info`].$refs.ItemInput[0]) {
                                    that.newSurgeryInfo.fact_surgery_items = that.$refs[`played-surgery-info`].$refs.ItemInput[0].value
                                }
                                resolve(that.newSurgeryInfo)
                            }
                        })
                        myPromise.then(() => {
                            that.saveOne()
                        })
                    })
                })
            })
        },
        saveOne() {
            let that = this
            console.log(`newSurgeryInfo`, that.newSurgeryInfo)
            let req = that.myaxios.put(`/api/Preoperative/Apply/PutAfterSurgery`, that.newSurgeryInfo)
            req.then(result => {
                if (that.surgeryInfo.enum_surgery_status >= 30 && that.IsHavePermission(that.factSurgeryShowPermission)) {
                    that.savePlayedSurgery(that.newSurgeryInfo)
                } else {
                    that.$message.success(`保存成功`)
                    that.loadOne()
                }
            }).catch(
                e => {
                    if (e.data.detail == `手术状态已更新，请重新操作`) {
                        this.loadOne().then(data => {
                            data.save = true
                            this.$emit(`changeSurgeInfo`, data)
                        })
                    }
                }
            )
        },
        savePlayedSurgery(data, errorAlert = true) {
            let that = this
            let showMode = this.showModifySurgeryMode
            try {
                var pddata = _.filter(data.fact_surgery_items, function(u) {
                    return u.is_empty == undefined || u.is_empty == false
                })
                if (errorAlert) {
                    let showColumns = []
                    if (this.$refs[`played-surgery-info`]) {
                        showColumns = this.$refs[`played-surgery-info`].columns[0].options
                    }
                    pddata.forEach(d => {
                        if (d.plan_surgeries == null) {
                            this.$message.error(`请选择手术名称！`)
                            throw new Error(`EndIterative`)
                        }
                        if (showMode == 2 && (d.plan_surgeries_name == null || d.plan_surgeries_name == ``)) {
                            this.$message.error(`请录入实际手术名称！`)
                            throw new Error(`EndIterative`)
                        }

                        if (d.plan_surgery_scale == null && showColumns.findIndex(item => item.label == `手术等级`) > -1 && that.required.indexOf(`手术等级`) > -1) {
                            this.$message.error(`请选择手术等级！`)
                            throw new Error(`EndIterative`)
                        }
                        if (d.plan_enum_cut_level == null && showColumns.findIndex(item => item.label == `切口等级`) > -1 && that.required.indexOf(`切口等级`) > -1) {
                            this.$message.error(`请选择切口等级！`)
                            throw new Error(`EndIterative`)
                        }
                        if (d.plan_surgery_region == null && showColumns.findIndex(item => item.label == `部位`) > -1 && that.required.indexOf(`部位`) > -1) {
                            this.$message.error(`请选择部位！`)
                            throw new Error(`EndIterative`)
                        }

                        if (d.plan_anaes_method == null && showColumns.findIndex(item => item.label == `麻醉方式`) > -1 && that.required.indexOf(`麻醉方式`) > -1) {
                            this.$message.error(`请选择麻醉方式！`)
                            throw new Error(`EndIterative`)
                        }

                        if (d.plan_surgery_position == null && showColumns.findIndex(item => item.label == `体位`) > -1 && that.required.indexOf(`体位`) > -1) {
                            this.$message.error(`请选择体位！`)
                            throw new Error(`EndIterative`)
                        }
                        if (d.dic_section == null && showColumns.findIndex(item => item.prop == `dic_section`) > -1 && that.required.indexOf(`科室`) > -1 && this.factSurgeryShowWorkerAndSection == `1`) {
                            this.$message.error(`请选择科室！`)
                            throw new Error(`EndIterative`)
                        }
                        if (d.dic_worker == null && showColumns.findIndex(item => item.prop == `dic_worker`) > -1 && that.required.indexOf(`手术医生`) > -1 && this.factSurgeryShowWorkerAndSection == `1`) {
                            this.$message.error(`请选择手术医生！`)
                            throw new Error(`EndIterative`)
                        }
                    })

                    let r = _.groupBy(pddata, d => d.plan_surgeries.value)
                    _.forEach(r, (g) => {
                        if (g.length > 1) {
                            this.$message.error(`手术名称重复`)
                            throw new Error(`EndIterative`)
                        }
                    })
                }
            } catch (e) {
                if (e.message != `EndIterative`) throw e
                return
            }
            if (data.id > 0) {
                let factsurgeryname = []
                let factItems = _.filter(data.fact_surgery_items, function(u) {
                    return u.is_empty == undefined || u.is_empty == false
                }).map(d => {
                    let s = {
                        plan_surgeries: d.plan_surgeries.value,
                        plan_surgery_scale: d.plan_surgery_scale,
                        plan_enum_cut_level: d.plan_enum_cut_level,
                        plan_surgery_region: d.plan_surgery_region,
                        plan_surgery_position: d.plan_surgery_position,
                        plan_anaes_method: d.plan_anaes_method,
                        dic_worker_id: d.dic_worker && d.dic_worker.value,
                        dic_section_id: d.dic_section && d.dic_section.value,
                        prefix_name: d.prefix_name,
                        behind_name: d.behind_name
                    }
                    if (showMode == 2) {
                        factsurgeryname.push(d.plan_surgeries_name)
                    }
                    return s
                })
                let obj = {
                    id: data.id,
                    fact_surgery_items: factItems,
                    surgery_items: null
                }

                // 处理实际手术名称可能和字典不一样
                if (showMode == 2) {
                    let summaryname = factsurgeryname && factsurgeryname.length > 0 ? factsurgeryname.join(`,`) : ``
                    let changeSummary = {
                        biz_surgery_info_id: data.id,
                        surgery: summaryname,
                        is_fasting: true
                    }
                    obj.change_summary_surgery = changeSummary
                }

                let req = this.myaxios.put(`/api/Preoperative/Apply/SavePlayedSurgery`, obj)
                let reqs2 = _.map(this.removeItems, d => {
                    return this.myaxios.delete(`/api/Preoperative/Apply/DeleteArrangeSurgery?arrangeSurgeryId=${d.id}`)
                })
                req = reqs2.concat(req)
                return new Promise((resolve, reject) => {
                    this.myaxios
                        .all(...req).then(res => {
                            if (errorAlert) {
                                this.$message.success(`保存成功`)
                            }
                            this.loadOne()
                            resolve(res)
                        }).catch((e) => reject(e))
                })
            }
        },
        receivePatient() {
            let that = this
            let evt = _.find(this.allTransEvents, d => d.label == `接患者`)
            if (!evt) {
                return
            }
            let req = this.myaxios.post(`/api/Nursing/PatientTransport/Post`, {
                remark: evt.label,
                dic_event_id: evt.value,
                biz_surgery_info_id: this.surgeryId,
                occur_time: Date.now(),
                enum_record_type: 90
            })
            req.then(data => {
                that.init()
            })
        },
        openCancelSurgery() {
            this.$confirm(`提示`, {
                title: `提示`,
                message: this.$createElement(`div`, [this.$createElement(`p`, `此操作将取消('${this.surgeryInfo.name}','${this.surgeryInfo.visit_no}')的已排程手术`), this.$createElement(`p`, `是否继续?`)]),
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            })
                .then(() => {
                    var col = _.find(this.overrule.columns, c => c.prop == `reject_reason`)
                    if (col) {
                        if (this.rejectReasons && this.rejectReasons.length > 0) {
                            col.options = this.rejectReasons
                            col.type = `select`
                        } else {
                            col.options = []
                            col.type = `string`
                        }
                    }
                    this.overrule.dialogFormVisible = true
                })
                .catch(e => {
                    console.log(e)
                })
        },
        // 取消手术，把状态改成 -1，加日志记录
        confirmCancelSurgery(row) {
            let that = this
            try {
                let req = that.myaxios.put(`/api/Preoperative/Schedule/CancelSurgery?surgeryId=${this.surgeryId}&&reason=${row.reject_reason}`)
                req.then(data => {
                    this.loadOne().then(data => {
                        that.$message.success(`手术取消成功`)
                        that.overrule.dialogFormVisible = false
                        that.$emit(`changeSurgeInfo`, data)
                    })
                })
            } catch (e) {
                that.$message.error(`手术取消失败`)
            }
        },
        modifySurgeryName(row) {
            // let r = { ...row }
            row.surgeryName = row.plan_surgeries.label
            this.modifySurgeryNameDialog.data = row
            this.modifySurgeryNameDialog.dialogFormVisible = true
        },
        confirmModifySurgeryName(row) {
            row.plan_surgeries.label = row.surgeryName
            this.$set(row, `plan_surgeries`, row.plan_surgeries)
            this.modifySurgeryNameDialog.dialogFormVisible = false
        },
        getToken() {
            let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/GetAuthToken`, {
                headers: { 'content-type': `application/x-www-form-urlencoded` }
            })
            req.then(res => {
                if (res != null && res.Status === `SUCCESS`) {
                    sessionStorage.setItem(`doctoken`, res.Content)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        // 获取文书模板列表
        loadDocumentList() {
            this.refeshDocument = true
            if (!this.currentSurgery || !this.currentUser || !this.currentSurgery.id) return
            let wardId = this.isOperationWard ? `ow_${this.currentSurgery.dic_operating_ward_id}` : `rw_${this.currentSurgery.dic_recovery_ward_id}`
            return new Promise((resolve, reject) => {
                let req = axios.get(`${this.$root.DOCSERVICE_BASE}/DocCenter/Setting/GetDicDocManagementList`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded`, 'Authorization': sessionStorage.getItem(`doctoken`) },
                    params: { deptno: `acis2020`, permission: `0-11111111111`, vid: this.currentSurgery.id }
                })
                let req2 = this.myaxios.getNoloading(`/api/AcisSystem/DocumentConfig/GetNoDeletes`)
                let req3 = axios.get(`${this.$root.DOCSERVICE_BASE}/DocCenter/Setting/GetDicDocPrintList`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded` },
                    params: { deptno: `acis2020`, permission: `0-11111111111`, vid: this.currentSurgery.id }
                })
                let req4 = this.myaxios.getNoloading(`/api/Operation/PaperlessDocRecord/GetBySurgeryId?surgeryId=${this.currentSurgery.id}`)

                this.myaxios.all(req, req2, req3, req4).then(([docmanagement, config, printlog, records]) => {
                    let vdoc = _.filter(config, d => {
                        return _.some(d.regions, rg => {
                            return (
                                (this.isOperationWard ? `ow_${rg.dic_operating_ward_id}` : `rw_${rg.dic_recovery_ward_id}`) == wardId &&
                                (d.enum_worker_role == null || d.enum_worker_role == 0 || d.enum_worker_role == (this.currentUser.worker_role == `医生` ? 1 : 2))
                            )
                        })
                    }).map(d => d.document_id)

                    this.documentList = _.filter(_.orderBy(docmanagement.data, `PrintOrder`), d => {
                        return _.includes(vdoc, d.DocNo)
                    }).map(d => {
                        let dc = _.find(config, c => c.document_id == d.DocNo)
                        let log = _.find(printlog.data, c => c.DocID == d.DocId)
                        d.index = `${d.DocNo}`
                        d.hasChildren = d.IsSurportHtml // 可编辑文书
                        d.children = []
                        d.label = d.DocName
                        d.is_singleton = dc && dc.is_singleton
                        d.printdt = log && log.DocID
                        d.archived = log && log.Archived
                        d.display_order = dc && dc.display_order
                        return d
                    })
                    this.documentList = _.orderBy(this.documentList, `display_order`)
                    _.forEach(this.documentList, d => {
                        if (d.hasChildren) {
                            // 根据DocNo获取文书实例
                            this.loadInstances(d.index)
                        } else {
                            d.uploadRec = _.find(records, rec => {
                                return rec.biz_id == d.DocId && rec.biz_type == 3
                            })
                            if (d.uploadRec && !d.archived) {
                                d.archived = d.uploadRec && d.uploadRec.is_deleted == 0 ? `archived` : ``
                            } else {
                                d.archived = ``
                            }

                            d.uploadTime = d.uploadRec ? this.$moment(d.uploadRec.last_upload_time).format(`YYYY/MM/DD HH:mm`) : ``
                        }
                    })
                })
            })
        },
        loadInstances(docno, docbizid) {
            let submenu = _.find(this.documentList, d => {
                return d.DocNo == docno
            })
            let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/QueryInstances`, {
                headers: { 'content-type': `application/x-www-form-urlencoded` },
                params: { docid: docno, dept: `acis2020`, vid: this.surgeryId, operator: this.currentUser.dic_worker_name }
            })
            req.then(data => {
                if (this.isTemplate == 0) {
                    submenu.children = _.filter(data.Content, d => {
                        return d.istemplate == `0`
                    }).map(d => {
                        d.index = `${d.docbizid}`
                        d.docno = submenu.DocNo
                        d.label = `${d.lastupdatedt}`
                        d.printdt = d.printdt
                        d.archiveddt = d.archiveddt
                        d.uploadRec = this.paperlessDocRecords.find(rec => {
                            return rec.biz_id == d.docbizid && rec.biz_type == 1
                        })
                        d.uploadTime = d.uploadRec ? this.$moment(d.uploadRec.last_upload_time).format(`YYYY/MM/DD HH:mm`) : ``
                        return d
                    })
                    if (submenu.is_singleton) {
                        submenu.uploadRec =
                            data.Content && data.Content.length > 0
                                ? this.paperlessDocRecords.find(rec => {
                                    return rec.biz_id == data.Content[0].docbizid && rec.biz_type == 1
                                })
                                : null
                        submenu.uploadTime = submenu.uploadRec ? this.$moment(submenu.uploadRec.last_upload_time).format(`YYYY/MM/DD HH:mm`) : ``
                    }
                } else {
                    submenu.children = _.filter(data.Content, d => {
                        return d.istemplate !== `0`
                    }).map(d => {
                        d.index = `${d.docbizid}`
                        d.docno = submenu.DocNo
                        d.label = d.docname
                        return d
                    })
                }

                if (submenu.DocNo == this.DocNo) {
                    this.loadDocumentPage(submenu)
                    if (docbizid) {
                        let nextActive = _.find(submenu.children, { docbizid: docbizid })
                        nextActive && this.activeDocument(nextActive)
                    }
                }
            })
        },
        // 加载当前文书模板
        loadDocumentPage(item) {
            window.localStorage.removeItem(`docsingleton`)
            window.localStorage.setItem(`docsingleton`, item.is_singleton)
            this.isSaveing = false
            this.singleItems = []
            if (this.hasChanged) {
                this.$confirm(`当前文书已修改, 是否保存?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`,
                    closeOnClickModal: false
                })
                    .then(() => {
                        this.nextActive = item
                        this.saveDocument()
                    })
                    .catch(e => {
                        this.hasChanged = false
                        this.activeDocument(item)
                    })
            } else {
                this.activeDocument(item)
            }
        },
        // 当DocFrame获取最新文书实例ID发生变化后暴露事件
        // updateDocbizid(docbizid) {
        //     this.docbizid = docbizid
        //     if (this.docbizid > 0) {
        //         let submenu = _.find(this.documentList, d => {
        //             return d.DocNo == this.$root.DOCUMENT.JBXX030
        //         })
        //         let nextActive = submenu && _.find(submenu.children, { docbizid: this.docbizid })
        //         nextActive && this.activeDocument(nextActive)
        //     }
        // },
        // 加载文书保存的模板
        loadTemplates(docno) {
            return new Promise((resolve, reject) => {
                let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/QueryTemplateInstances`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded` },
                    params: { docid: docno, deptno: ``, vid: this.surgeryId, operator: this.currentUser.dic_worker_name }
                })
                req.then(res => {
                    resolve(
                        res.Content &&
                            res.Content.map(d => {
                                return {
                                    label: d.docname,
                                    value: parseInt(d.docbizid),
                                    group: d.istemplate == `1` ? `区域模板` : `私有模板`,
                                    docguid: d.docguid
                                }
                            })
                    )
                })
            })
        },
        // 激活当前文书
        activeDocument(item) {
            if (_.has(item, `docbizid`)) {
                // 打开文书实列
                this.activeDoc = {
                    docid: item.docid,
                    docno: item.docno,
                    isSurportHtml: true,
                    docName: item.docname,
                    guid: item.guid,
                    docbizid: item.docbizid,
                    archived: item.archiveddt !== ``,
                    datetype: item.datetype,
                    templateid: item.templateid,
                    templates: item.templates,
                    daterange: this.$moment().format(`YYYY/MM/DD HH:mm`),
                    occurdate: this.$moment().format(`YYYY/MM/DD HH:mm`),
                    fromDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                    toDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                    hasChildren: item.hasChildren,
                    is_singleton: item.is_singleton
                }
            } else if (item.is_singleton) {
                // 单例文书
                let docname = `acis2020_${item.DocNo}_${this.surgeryId}`
                let doced
                if (item.children && item.children.length > 0) {
                    doced = item.children[0]
                }
                this.loadTemplates(item.DocId).then(data => {
                    this.activeDocument({
                        docid: (doced && doced.docid) || item.DocNo,
                        docno: (doced && doced.docno) || item.DocNo,
                        docname: doced ? doced.docname : docname,
                        guid: doced ? doced.docguid : this.generateUUID(),
                        docbizid: doced ? doced.docbizid : ``,
                        archiveddt: doced ? doced.archiveddt : ``,
                        datetype: item.DateArea,
                        templateid: undefined,
                        daterange: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        occurdate: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        templates: data,
                        fromDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        toDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        hasChildren: !!doced,
                        is_singleton: item.is_singleton
                    })
                })

                return
            } else {
                // 打开只读文书
                this.activeDoc = {
                    docid: item.DocNo,
                    docno: item.DocNo,
                    isSurportHtml: false,
                    archived: this.archivedIds.indexOf(item.DocNo.toString()) > -1,
                    docName: ``,
                    guid: ``,
                    docbizid: ``,
                    datetype: item.DateArea,
                    templateid: undefined,
                    daterange: this.$moment().format(`YYYY/MM/DD HH:mm`),
                    occurdate: this.$moment().format(`YYYY/MM/DD HH:mm`),
                    fromDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                    toDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                    hasChildren: false
                }
            }
            this.nextActive = undefined
            if (this.$root.DOCUMENT && this.refeshDocument) {
                this.$nextTick(() => {
                    this.$refs[`doc`] && this.$refs[`doc`].loadDocument()
                })
            }
        },
        printDocment() {
            // // 归档的文书不需要保存
            if (this.activeDoc.isSurportHtml && !this.currentSurgery.is_sealed && !this.activeDoc.archived) {
                this.saveDocument()
            }
            let awaitIndex = 0
            let awaitUntilEqual = () => {
                awaitIndex++
                if (this.isSaving == true && awaitIndex < 500) {
                    requestAnimationFrame(awaitUntilEqual)
                    return
                }
                let savefalg = window.localStorage.getItem(`savefalg`)
                if (savefalg == `False`) {
                    this.$message.error(`请先保存文书`)
                    return
                }
                if (this.isCanPrintDocAfterArchived && this.isCanPrintDocAfterArchived == `1`) {
                    if (!this.currentSurgery.is_sealed && !this.activeDoc.archived) {
                        this.$message.error(`请先归档`)
                        return
                    }
                }

                if (awaitIndex >= 500) {
                    this.$message.error(`打印超时，请刷新后重试~`)
                } else {
                    this.$refs.doc.print()
                    // setTimeout(this.loadDocumentList, 3000)
                }
            }
            awaitUntilEqual()
        },
        changed(changed) {
            this.hasChanged = changed
        },
        // 文书归档
        archive(c) {
            if (c.isSurportHtml) {
                if (c.templateid) {
                    this.$message.error(`归档之前请先保存！`)
                    return
                }
                let awaitIndex = 0
                let awaitUntilEqual = () => {
                    awaitIndex++
                    if (this.isSaving == true && awaitIndex < 500) {
                        requestAnimationFrame(awaitUntilEqual)
                        return
                    }
                    if (awaitIndex >= 500) {
                        this.$message.error(`操作超时，请刷新后重试~`)
                    } else {
                        this.$refs.doc.archive()
                    }
                }
                awaitUntilEqual()
            } else {
                this.$confirm(`确定要将此文书归档吗, 是否继续?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`,
                    closeOnClickModal: false
                }).then(() => {
                    let data = {
                        id: 0,
                        biz_surgeryInfo_id: this.surgeryId,
                        docdt: this.$moment().format(`YYYY-MM-DD HH:mm:ss`),
                        archivedt: this.$moment().format(`YYYY-MM-DD HH:mm:ss`),
                        docname: `${this.$moment().format(`YYYYMMDD`)}_${c.docid}_${this.surgeryId}`,
                        docid: c.docid
                    }
                    let req = this.myaxios.put(`/api/AcisSystem/DocumentConfig/Archive`, data)
                    req.then(data => {
                        this.archivedId = data.id
                        this.archivedIds.push(data.docid)
                        this.activeDoc.archived = true
                        this.saveReadOnlyPaperlessRecord(data)
                        this.refeshDocument = false
                        this.loadInstances(this.activeDoc.docno)
                    })
                })
            }
            // setTimeout(this.loadDocumentList, 3000)
        },
        afterArchive() {
            this.activeDoc.archived = true
            // 保存无纸化记录
            this.savePaperlessRecord(this.activeDoc.docbizid)
            this.refeshDocument = false
            this.loadInstances(this.activeDoc.docno)
        },
        generateUUID() {
            var d = new Date().getTime()
            var uuid = `xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx`.replace(/[xy]/g, function(c) {
                var r = (d + Math.random() * 16) % 16 | 0
                d = Math.floor(d / 16)
                return (c == `x` ? r : (r & 0x3) | 0x8).toString(16)
            })
            return uuid
        },
        disArchive(c) {
            if (c.isSurportHtml) {
                if (c.templateid) {
                    this.$message.error(`模板不能取消归档,请刷新文书！`)
                    return
                }
                this.checkPaperlessDoc(c && c.docbizid).then(result => {
                    if (result) {
                        let awaitIndex = 0
                        let awaitUntilEqual = () => {
                            awaitIndex++
                            if (this.isSaving == true && awaitIndex < 500) {
                                requestAnimationFrame(awaitUntilEqual)
                                return
                            }
                            if (awaitIndex >= 500) {
                                this.$message.error(`操作超时，请刷新后重试~`)
                            } else {
                                this.$refs.doc.disArchive()
                                // setTimeout(this.loadDocumentList, 3000)
                            }
                        }
                        awaitUntilEqual()
                    }
                })
            } else {
                this.checkPaperlessDoc(c && c.docbizid).then(result => {
                    if (result) {
                        let req1 = this.myaxios.get(`/api/AcisSystem/DocumentConfig/GetArchivedByDocId?docid=${c.docid}`)
                        req1.then(data => {
                            return data.id
                        }).then(id => {
                            let req = this.myaxios.put(`/api/AcisSystem/DocumentConfig/CancleArchive?archiveid=${id}`)
                            req.then(data => {
                                this.archivedIds.splice(this.archivedIds.indexOf(data.docid), 1)
                                this.activeDoc.archived = false
                                this.deleteReadOnlyPaperlessRecord(data.docid)
                                this.refeshDocument = false
                                this.loadInstances(this.activeDoc.docno)
                                // setTimeout(this.loadDocumentList, 3000)
                            })
                        })
                    }
                })
            }
        },
        // 无纸化文档校验
        checkPaperlessDoc(bizid) {
            return new Promise((resolve, reject) => {
                let that = this
                if (that.paperlessDocVerification && that.paperlessDocVerification != ``) {
                    let postdata = {
                        biz_surgery_info_id: that.surgeryId,
                        biz_type: 1,
                        biz_id: bizid
                    }
                    let req = this.myaxios.post(`/api/Operation/Home/checkPaperlessDoc`, postdata)
                    req.then(data => {
                        if (data) {
                            if (!data.Status && data.Message) {
                                that.$message.error(data.Message)
                            }
                            resolve(data && data.Status)
                        } else {
                            resolve(true)
                        }
                    })
                        .catch(e => {
                            console.log(e)
                            resolve(false)
                        })
                } else {
                    resolve(true)
                }
            })
        },
        afterDisarchive() {
            this.activeDoc.archived = false
            this.deletePaperlessRecord(this.activeDoc.docbizid)
            this.refeshDocument = false
            this.loadInstances(this.activeDoc.docno)
        },
        templateChange(refresh) {
            if (!this.activeDoc.docbizid) {
                this.$message.error(`切换模板过快了~~，请稍后重试呀`)
                return
            }
            let curDoc = _.find(this.singleItems, d => d.docno == this.activeDoc.docno)
            if (!curDoc) {
                curDoc = {
                    docno: this.activeDoc.docno,
                    docbizid: this.activeDoc.docbizid,
                    guid: this.activeDoc.guid,
                    docname: this.activeDoc.docname
                }
                this.singleItems.push(curDoc)
            }
            if (!this.activeDoc.templateid || this.activeDoc.templateid <= 0) {
                this.activeDoc.templateid = undefined
                this.activeDoc.docname = curDoc.docname
                this.activeDoc.docbizid = curDoc.docbizid
                this.activeDoc.guid = curDoc.guid
                if (refresh != false) {
                    this.$nextTick(() => {
                        this.$refs[`doc`].loadDocument()
                    })
                }
            } else {
                let choseTmpt = _.find(this.activeDoc.templates, c => c.value == this.activeDoc.templateid)
                if (!choseTmpt) {
                    this.$message.error(`切换模板失败了~~，请稍后重试呀`)
                    return
                }
                this.activeDoc.docname = choseTmpt.label
                this.activeDoc.docbizid = choseTmpt.value.toString()
                this.activeDoc.guid = choseTmpt.docguid
                this.$nextTick(() => {
                    this.$refs[`doc`].loadDocument(curDoc.docno, curDoc.docbizid, curDoc.guid)
                })
            }
        },
        savePaperlessRecord(docbizid) {
            if (this.$root.PaperlessEnabled != 1) {
                return Promise.resolve({})
            }

            // 保存无纸化记录,文书3.2.6才会支持Content数据返回[jira:ICIS-13291]
            if (docbizid > 0) {
                // 查询归档信息
                let req1 = axios.get(`${this.$root.DOCSERVICE_BASE}/wth/QueryInstanceById`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded` },
                    params: { docbizid: docbizid }
                })

                req1.then(doc => {
                    if (!doc || doc.ArchivedDt == ``) {
                        return Promise.resolve({})
                    }
                    let recData = {
                        biz_id: doc.Content.Sysid,
                        biz_surgery_info_id: doc.Content.Vid,
                        biz_type: 1, // 0麻醉单和苏醒单，1文书
                        doc_name: doc.Content.DocName,
                        file_path: `${doc.Content.Guid}.pdf`,
                        create_by: this.currentUser.username,
                        create_by_name: this.currentUser.dic_worker_name,
                        create_time: doc.Content.ArchivedDt
                    }
                    return this.myaxios.post(`api/Operation/PaperlessDocRecord/Add`, recData)
                })
            }
            return Promise.resolve({})
        },
        deletePaperlessRecord(docbizid) {
            if (this.$root.PaperlessEnabled != 1) {
                return Promise.resolve({})
            }

            // 保存无纸化记录,文书3.2.6才会支持Content数据返回[jira:ICIS-13291]
            if (docbizid > 0) {
                return this.myaxios.put(`api/Operation/PaperlessDocRecord/LogicDel?biz_id=${docbizid}&biz_type=1`)
            }
            return Promise.resolve({})
        },
        saveReadOnlyPaperlessRecord(data) {
            if (this.$root.PaperlessEnabled != 1) {
                return Promise.resolve({})
            }
            if (data.id) {
                let recData = {
                    biz_id: data.docid,
                    biz_surgery_info_id: data.biz_surgeryInfo_id,
                    biz_type: 3, // 0麻醉单和苏醒单，1文书,3 只读文书
                    doc_name: data.docname,
                    file_path: `${data.docname}.pdf`,
                    create_by: this.currentUser.username,
                    create_by_name: this.currentUser.dic_worker_name,
                    create_time: this.$moment(data.archivedt).format(`YYYY-MM-DD HH:mm:ss`)
                }
                this.myaxios.post(`api/Operation/PaperlessDocRecord/Add`, recData)
                setTimeout(this.loadDocumentList, 3000)
            }

            return Promise.resolve({})
        },
        deleteReadOnlyPaperlessRecord(docid) {
            if (this.$root.PaperlessEnabled != 1) {
                return Promise.resolve({})
            }
            if (docid) {
                this.myaxios.put(`api/Operation/PaperlessDocRecord/LogicDel?biz_id=${docid}&biz_type=3`)
                setTimeout(this.loadDocumentList, 3000)
            }
            return Promise.resolve({})
        },
        // 直接刷新
        refreshDocument() {
            this.$confirm(`确定要刷新当前文书数据, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            })
                .then(() => {
                    this.saveDocument()
                    this.$refs.doc.dataUpdate()
                    this.$refs[`doc`].loadDocument()
                })
                .catch(e => {
                    this.hasChanged = false
                })
        },
        saveAsTemplate(type) {
            this.$refs.doc.saveAsTemplate(type)
        },
        saveDocument() {
            this.isSaving = true
            this.$refs.doc.save()
            this.visible = false
        },
        afterActiveSaved() {
            this.hasChanged = false
            this.refeshDocument = false
            this.loadInstances(this.activeDoc.docno)

            if (this.activeDoc.is_singleton && this.activeDoc.templateid) {
                this.activeDoc.templateid = undefined
                this.templateChange(false)
            } else {
                if (this.nextActive) {
                    this.activeDocument(this.nextActive)
                } else {
                    this.$set(this.activeDoc, `hasChildren`, true)
                }
            }
            this.isSaving = false
        },
        afterSaveasTemplate() {
            // 另存为模板后加载最新的模板到模板列表
            this.loadTemplates(this.activeDoc.docid).then(data => {
                this.activeDoc.templates = data
            })
        },
        surgerieChange(row) {
            console.log(`qqqqqqqqqqqqqqqqqqqqqqq`, row)
            if (row.is_empty) {
                this.$set(row, `is_empty`, false)
                this.surgeryInfo.fact_surgery_items.push({ is_empty: true })
            }
            if (_.isEmpty(row.plan_surgeries)) {
                row.plan_surgery_scale = undefined
            } else {
                var max = -1
                try {
                    if (row.plan_surgeries.description) {
                        let level = parseInt(row.plan_surgeries.description)
                        if (level > max) { max = level }
                    }
                } catch (err) {
                    console.log(err)
                }
                if (max > 0) {
                    row.plan_surgery_scale = max
                } else {
                    row.plan_surgery_scale = undefined
                }
            }
            this.$set(row, `showChange`, true)
        }, // 事件方法
        getReload() {
            this.reload() // 重置刷新
        }
    },
    inject: [`reload`],
    beforeDestroy() {
        // 把Tab页签展开折叠记录到session里
        sessionStorage.setItem(`BasicTabUpDown`, JSON.stringify(this.drawer))
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.getReload()
            // this.surgeryId = newUrl.query.surgery_id
            // this.activeDoc = undefined
            // this.archivedIds = []
            // this.init()
        },
        // ACIS-24884 切换患者级菜单，扩展字典出现加载不出数据的情况,当loadOne方法时
        // surgeryInfoExtraParamUtil.SetSurgeryInfoObj extendColumnList 为空时,扩展字段加载不上值
        extendColumnList: function(val) {
            this.init()
        }

    }
}
</script>
<style scoped lang="less">
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
.steps {
    overflow: hidden !important;
}
.playedsurgery /deep/ .cus-form .el-form-item.left .el-form-item__content {
    margin-left: 0px;
}
</style>
<style lang="less">
.plan_diseases{
    .el-select__tags-text{
        white-space:normal;
    }
    .el-tag--mini{
        height: unset !important;
    }
}
.plan_surgeries{
    .el-select__tags-text{
        white-space:normal;
    }
    .el-tag--mini{
        height: unset !important;
    }
}
.title1 p {
    background: #ebecef;
    font-size: 20px;
}
.jieban {
    margin-top: -10px;
    margin-bottom: 2px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Basic/Index.vue